export const formatLanguages = (langs) => {
    if (!langs) {
        return [];
    }

    return langs.map(({
        id, title, code, url, icon
    }) => {
        const item = {
            children: [],
            hasArror: false,
            id,
            name: title,
            slug: code,
            url,
            icon
        };
        return item;
    });
};
